<template>
  <section class="py-20 px-4" style="background-color: var(--color-krate-blue-900);">
    <div class="max-w-4xl mx-auto">
      <p class="text-center text-2xl md:text-3xl font-semibold mb-16" style="color: white;">
        Zero to kernel-isolated dev environments in <span style="color: #facc15;">3 commands</span>.
      </p>
      <pre class="rounded-lg p-8 overflow-x-auto text-base md:text-lg leading-relaxed" style="background-color: #303446; color: #c6d0f5; font-family: var(--font-mono);">
<span style="color: #949cbb;"># 1. Install</span>
<span style="color: #a6d189;">$</span> <span style="color: #e5c890;">brew install krate-dot-sh/tap/krate</span>

<span style="color: #949cbb;"># 2. Authenticate (GitHub OAuth, takes 5 seconds)</span>
<span style="color: #a6d189;">$</span> <span style="color: #e5c890;">krate login</span>

<span style="color: #949cbb;"># 3. Run a workload</span>
<span style="color: #a6d189;">$</span> <span style="color: #e5c890;">krate run hello-krate</span>
<span style="color: #c6d0f5;">Hello from krate!</span></pre>
      <p class="text-center text-sm mt-6" style="color: var(--color-krate-blue-200);">
        Run a workload in <span style="color: #facc15; font-weight: 600;">under 1 second</span>.
      </p>
    </div>
  </section>
</template>
